import { render } from "./ContactParent.vue?vue&type=template&id=524e994a&ts=true"
import script from "./ContactParent.vue?vue&type=script&lang=ts"
export * from "./ContactParent.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src599522923/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__